/**
 * Opportunity + Manager product catalog from Ops Deal Types only.
 * Admin `organizations.product_types` is retired.
 */
import type { ProductTypeEntry } from "@/hooks/useOrgSettings";

export type DealTypeCatalogProduct = {
  type_key: string;
  display_name: string;
  description?: string;
  is_active?: boolean;
  sort_order?: number;
  follow_on?: boolean;
};

function trimTag(raw: string | undefined): string {
  return typeof raw === "string" ? raw.trim() : "";
}

export function catalogFromDealTypes(
  dealTypes: ReadonlyArray<DealTypeCatalogProduct> | null | undefined,
): ProductTypeEntry[] {
  const dts = Array.isArray(dealTypes) ? [...dealTypes] : [];
  dts.sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));

  const seen = new Set<string>();
  const out: ProductTypeEntry[] = [];
  for (const dt of dts) {
    if (dt.is_active === false) continue;
    const tag = trimTag(dt.type_key);
    if (!tag || seen.has(tag)) continue;
    seen.add(tag);
    out.push({
      tag,
      label: dt.display_name.trim() || tag,
      description: dt.description?.trim() || "",
      followOn: dt.follow_on === true,
    });
  }
  return out;
}
